<a cf-link size="sm" (click)="emitBack.emit()" class="back-btn">
  <svg cfIcon="chevron_down" class="tw:text-blue-50 tw:rotate-90"></svg>
  {{ "back" | translate }}
</a>

<div class="row g-5">
  <div class="col-xl-6 d-none d-xl-block">
    <div class="card">
      <cf-booking-information
        [label]="'booking.reschedule_to' | translate"
        [day]="day"
        [time]="time"
        [timezone]="timezone"
        [duration]="duration"
        [location]="event.event_location"
        [participantsTmp]="participantsTmp"
      >
        <ng-template #participantsTmp>
          <cf-participant-list [role]="event.role" [participants]="participants"></cf-participant-list>
        </ng-template>
      </cf-booking-information>
    </div>
  </div>

  <div class="col-xl-6" [formGroup]="form">
    <h3 class="mb-3 d-none d-xl-block">
      {{ "booking.reason_for_change" | translate }}
    </h3>
    <cf-form-field class="mb-12">
      <textarea
        cf-input
        formControlName="reason_for_change"
        [placeholder]="'booking.reason_for_change_placeholder' | translate: { name: event.organizer.name }"
        rows="4"
      ></textarea>
      <cf-input-error [error]="form.controls.reason_for_change.errors">
        {{ "booking.reschedule_reason" | translate }}
      </cf-input-error>
    </cf-form-field>

    <div class="action mt-4">
      <cf-button class="d-block w-100" color="primary" className="w-100" [disabled]="form.invalid" (click)="submit()">
        {{ "booking.update_event" | translate }}
      </cf-button>

      <cf-text class="d-block mt-4" color="grey-60" size="sm" *ngIf="participantNames.length">
        {{ "booking.reason_for_change_hint" | translate }}
        {{ participantNames.join(", ") }}.
      </cf-text>
    </div>
  </div>
</div>
